<template>
  <div class="manual-settlements-list page page-with-table p-2">
    <page-header class="mb-2">
      <template v-slot:title>
        <div style="flex: 1">
          <h1 class="mb-0">{{ $t('Settlements') }}</h1>
        </div>
      </template>
    </page-header>
    <div class="card content-wrapper">
      <div class="pl-2 pr-2 pt-2  pb-0">
        <div class="row">
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Amount')" text-class="text-primary" key="items-general-info"
                           :amount="totalAmount" icon="money-bill"/>
          </div>
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Paid Amount')" text-class="text-success" key="items-general-info"
                           :amount="totalPaidAmount" icon="money-bill"/>
          </div>
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Outstanding Amount')" text-class="text-danger" key="items-general-info"
                           :amount="totalOutstandingAmount" icon="money-bill"/>
          </div>
        </div>
      </div>
      <settlement-table :hide-actions="hideActions" enable-frontend-export/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import SettlementTable from "../../settlements/SettlementTable";
  import {ACTION_BATCH_SETTLEMENT_GENERATE} from "../../constants";
  import AmountViewer from "@/core/components/common/AmountViewer";
  import {ON_SETTLEMENTS_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
  import SettlementService from "@/modules/settlements/SettlementService";

  const {mapActions} = createNamespacedHelpers('settlements');

  export default {
    name: "Settlements",
    components: {SettlementTable, PageHeader, AmountViewer},
    data() {
      return {
        hideActions: [
          ACTION_BATCH_SETTLEMENT_GENERATE,
        ],
        totalAmount: {},
        totalPaidAmount: {},
        totalOutstandingAmount: {},
      }
    },
    methods: {
      ...mapActions(['updateTableSource']),
      async getFilteredSettlementsTotalAmounts({params}) {
        let response = await SettlementService.getSettlementsTotalAmounts(params)
        if (response.success) {
          this.$set(this, 'totalAmount', response.body.total_amount)
          this.$set(this, 'totalPaidAmount', response.body.total_paid_amount)
          this.$set(this, 'totalOutstandingAmount', response.body.total_outstanding_amount)
        }
      }
    },
    async beforeMount() {
      this.$evBus.$on(ON_SETTLEMENTS_TABLE_GET_TABLE_DATA, this.getFilteredSettlementsTotalAmounts);
      await this.updateTableSource({
        source: 'settlements',
        extraFilters: {is_manual: true},
      });
    },
    beforeDestroy() {
      this.$evBus.$off(ON_SETTLEMENTS_TABLE_GET_TABLE_DATA);
    }
  }
</script>

<style scoped lang="scss">
  @import "./scss/variables.scss";

  .settlements-list {
    @include list-view-wrapper;
  }
</style>
